import React from 'react';
import { Flex, Avatar, Typography, useAuth } from '@medicalwebexperts/ui';

const LoggedUserAvatar = () => {
  const { user } = useAuth();
  const userName = `${user.lastName} ${user.firstName}`;

  return (
    <Flex alignItems="center">
      <Avatar
        size="xs"
        name={userName}
        classes={{ root: { size: 8, fontSize: 'sm', mr: 2 } }}
      />
      <Typography variant="body2">{userName}</Typography>
    </Flex>
  );
};

export default LoggedUserAvatar;
